<template>
  <!-- <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 122 146"
    style="enable-background: new 0 0 122 146"
    xml:space="preserve"
  > -->
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 122 95"
    style="enable-background: new 0 0 122 95"
    xml:space="preserve"
  >
    <g></g>
    <g></g>
    <g class="st0"></g>
    <g>
      <g>
        <!-- <g>
          <g class="st3">
            <path
              class="st4"
              d="M25.04,130.33c-0.32,5.879-0.6,8.198-1.479,12.118l-3.399-1.72c0.96-3.24,1.399-6.399,1.52-10.999
                    L25.04,130.33z M32.159,129.129l-0.32-1.72c-0.84,0.12-1.16,0.16-2.04,0.24v12.357c0,2.4,0.04,3.36,0.2,4.52H25.84
                    c0.2-1.239,0.24-2.199,0.24-4.52V127.93c-4.08,0.279-4.72,0.359-5.399,0.52l-0.36-4.199c0.641,0.12,1.04,0.16,1.88,0.16
                    c0.12,0,0.48,0,0.76,0c0.96-1.28,1.24-1.68,2.04-2.8c-1.28-2.04-3.039-4.319-4.64-6.039l2-3.479l1.24,1.439
                    c1.399-2.359,2.359-4.559,2.759-6.318l3.76,1.64c-1.52,3.079-2.76,5.359-4.199,7.559c0.72,0.92,0.88,1.2,1.319,1.84
                    c2-3.159,3.08-5.119,3.6-6.599l3.52,1.8c0-1.36-0.04-1.8-0.16-2.52c0.84,0.079,1.92,0.119,3.52,0.119h5.919v-0.64
                    c0-1.239-0.08-2-0.2-2.76h4.6c-0.16,0.84-0.2,1.6-0.2,2.84v0.56h5.799c1.84,0,2.88-0.04,3.8-0.199
                    c-0.12,0.8-0.16,1.52-0.16,2.679v2.36c0,1.159,0.04,1.8,0.16,2.56h-1.2v2.799c-0.92-0.119-1.6-0.159-2.799-0.159h-1.84
                    c-0.36,1.359-0.48,1.76-1,3.199h2.279c1.56,0,2.399-0.04,3.52-0.12c-0.12,1.12-0.16,2.04-0.16,3.72v12.478
                    c0,1.72,0.08,2.8,0.24,4.159h-3.959v-1.84h-5.959v1.8h-3.96c0.16-1.199,0.2-1.959,0.2-3.799V127.73c0-1.76-0.04-2.479-0.16-3.56
                    c1,0.08,1.72,0.12,3.439,0.12h0.48c0.399-0.92,0.8-2.04,1.079-3.199h-1.839c-1.28,0-2.04,0.04-2.92,0.159v-3.599
                    c-1.08,3.279-1.08,3.279-2.279,6.118v18.157c0,0.76,0.04,1.72,0.12,2.56h-4.08c0.2-1.159,0.24-2.319,0.24-4.559v-6.68
                    c0-1.279,0-1.68,0.12-3.679c-0.48,0.92-0.92,1.56-1.64,2.479c-0.4-1.12-0.96-2.32-1.68-3.52L32.159,129.129z M32.759,119.971
                    c1.08,2.56,1.56,3.999,2.119,6.279c0.88-1.36,1.88-3.08,2.68-4.88c0.92-2.079,1.32-3.279,1.8-5.759l3.84,1.12l-0.24,0.6
                    c1.04,0.12,1.64,0.16,2.959,0.16h7.319v-2.8H38.357v4.6h-4.159c0.12-0.88,0.16-1.64,0.16-2.64v-2.92
                    c-0.28,0.4-0.56,0.8-1.12,1.72c-1.919,3.12-4.359,6.6-6.238,8.839c1.879-0.08,2.879-0.16,3.999-0.32
                    c-0.32-0.92-0.52-1.479-1.08-2.879L32.759,119.971z M33.679,129.69c0.72,3.919,1,5.959,1.279,9.638l-3.159,0.84
                    c-0.16-3.759-0.4-5.959-1.04-9.758L33.679,129.69z M46.557,131.489h5.959v-3.599h-5.959V131.489z M46.557,139.048h5.959v-4.08
                    h-5.959V139.048z"
            />
            <path
              class="st4"
              d="M73.679,117.772c-0.08,0.199-0.12,0.359-0.16,0.479c-0.12,0.479-0.12,0.52-0.239,0.96
                    c-1.84,8.398-3.52,12.678-7.199,18.396c-1.64-1.359-2.8-2.119-4.239-2.839c3.84-5.279,6.519-12.198,6.999-18.237L73.679,117.772
                    z M83.717,108.133c-0.159,1.239-0.239,2.8-0.239,4.879v26.436c0,1.92-0.521,3.119-1.64,3.76c-0.8,0.479-1.96,0.68-4.16,0.68
                    c-1.52,0-3.199-0.08-5.119-0.2c-0.239-1.8-0.56-2.999-1.279-4.679c2.479,0.359,4.159,0.52,5.719,0.52c1.32,0,1.72-0.2,1.72-0.96
                    v-25.596c0-2.039-0.08-3.6-0.239-4.839H83.717z M92.556,116.372c0.28,2.12,0.8,4.239,1.84,7.039
                    c1.479,4.079,3.359,7.559,5.959,11.038c-1.6,0.92-2.96,2-4.039,3.119c-3.359-4.799-5.399-9.158-7.119-15.157
                    c-0.04-0.16-0.44-1.72-1.24-4.719L92.556,116.372z"
            />
          </g>
        </g> -->
        <circle class="st4" cx="61" cy="46.016" r="44.543" />
        <g>
          <path
            class="st5"
            d="M81.635,49.016h-41.27c-1.657,0-3-1.343-3-3s1.343-3,3-3h41.27c1.657,0,3,1.343,3,3
                S83.292,49.016,81.635,49.016z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {};
</script>
<style lang="scss">
.st0 {
  display: none;
}
// .st1 {
//   display: inline;
//   fill: #d2ddf0;
// }
// .st2 {
//   display: inline;
//   fill: #1e58b5;
// }
.st3 {
  enable-background: new;
}
.st4 {
  fill: #ffffff;
}
.st5 {
  fill: #3041a5;
}
// .st6 {
//   fill: none;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st7 {
//   fill: #ffffff;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st8 {
//   fill: #1e58b5;
//   stroke: #1e58b5;
//   stroke-width: 4;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st9 {
//   fill: none;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
</style>